import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User toggled email digest on',
  name: 'toggled_email_digest_on',
};

export default META;
